module.exports = __webpack_public_path__ + "img/gian_piero_morga.ff6a2b49.png";